<template>
  <el-dialog @close='close' title="智能打印" :visible.sync="printFilterDialogVisible" width="600px" center>
    <el-form ref="added" :model="formData" size="medium">
      <el-form-item label="通话记录上传时间：">
        <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              @change='onChange'
              format='yyyy-MM-dd'
              value-format="yyyy-MM-dd"
              unlink-panels
              end-placeholder="结束日期">
            </el-date-picker>
      </el-form-item>
    </el-form>
    <span class="flex-ct" style="padding-top: 30px;">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="handelConfirm">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default{
    data(){
      return{
        printFilterDialogVisible: false,
        date: '',
        formData:{
          call_record_begin_time: '',
          call_record_end_time: ''
        },
        rules: {
          user_name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'change'
          }]
        },
        query: ''
      }
    },
    methods:{
      show(query){
        this.loading = false
        this.query = query
        this.printFilterDialogVisible = true
      },
      onChange(e){
        if(e){
          this.formData.call_record_begin_time = e[0]
          this.formData.call_record_end_time = e[1]
        }else{
          this.formData.call_record_begin_time = ''
          this.formData.call_record_end_time = ''
        }
      },
      close() {
        this.printFilterDialogVisible = false;
      },
      handelConfirm(){
        this.loading = true
        if(!this.formData.call_record_begin_time){
          this.$emit('success', -1)
          this.close()
        }else{
          userInfoAPI.customerList({
            ...this.query,
            ...this.formData
          }).then(res => {
            if (res.data.code == 0) {
              let list = res.data.data.list || []
              if(!list.length){
                this.$message.error('该时间段无相关服务对象记录，请重新选择')
              }else{
                this.$emit('success', list)
              }
            }
            this.close()
          })
        }

      }
    }
  }
</script>

<style>
</style>